var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { ClassNames } from '@emotion/core';
import { variables as vars } from '@domain-group/fe-brary';
import PropTypes from 'prop-types';
import { format, isAfter, isSameDay, startOfDay, startOfToday, startOfTomorrow } from 'date-fns';
import { Button, LinkButton } from '@domain-group/fe-co-button';
import Tooltip from '@domain-group/fe-co-tooltip';
import { validEmail } from '@domain-group/fe-helper';
import Loader from '@domain-group/fe-co-loader';
import DomainLogo from '@domain-group/fe-co-domain-logo';
import { isValidNumber } from 'libphonenumber-js';
import * as styles from '../styles/homepass-booking/homepass-booking-structure';
import ContactField from './components/contact-field';
import ConfirmationPage from './components/confirmation-page';
import CustomDateDialog from './components/custom-date-dialog';
import SelectInspection from './components/select-inspection';
import CustomDateInputs from './components/custom-date-inputs';
import { FIRST_INSPECTION_TIME, LAST_INSPECTION_TIME, TIME_INTERVAL } from './constant';
import { jsx as ___EmotionJSX } from "@emotion/core";
var REQUIRED = '*';
export var FORMAT_TIME = 'h:mm a';
var FORMAT_DATE_AND_TIME = "ddd DD MMM, ".concat(FORMAT_TIME);
var COUNTRY_NUMBER_FORMAT = 'AU';
class HomepassBookingForm extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onCloseModalCallback", () => {
      this.resetForm();
      this.props.onCloseModalCallback();
    });
    _defineProperty(this, "onChangeInspectionOption", _ref => {
      var value = _ref.value;
      this.setState({
        isAvailableCalendarEvent: false,
        calendarEventsIndex: value,
        startDateError: false
      });
    });
    _defineProperty(this, "getTimeSlots", _ref2 => {
      var index = _ref2.index,
        hour = _ref2.hour,
        day = _ref2.day,
        startMinsOffset = _ref2.startMinsOffset,
        endMinsOffset = _ref2.endMinsOffset,
        hrsOffset = _ref2.hrsOffset;
      return {
        value: "".concat(index),
        label: "".concat(format(new Date(day).setHours(hour, startMinsOffset), 'h:mm'), " - ").concat(format(new Date(day).setHours(hour + hrsOffset, endMinsOffset), FORMAT_TIME)),
        startTime: {
          hour,
          startMinsOffset
        },
        endTime: {
          hour: hour + hrsOffset,
          endMinsOffset
        }
      };
    });
    _defineProperty(this, "getFieldValue", key => this.state.contactFields[key].value);
    _defineProperty(this, "getSelectedDateTime", () => {
      var timeSlot = this.state.availableCalendarEventsTimeOptions[this.state.availableCalendarEventsIndex];
      return {
        startDate: new Date(this.state.availableCalendarEventsSelectedDate).setHours(timeSlot.startTime.hour, timeSlot.startTime.startMinsOffset),
        endDate: new Date(this.state.availableCalendarEventsSelectedDate).setHours(timeSlot.endTime.hour, timeSlot.endTime.endMinsOffset)
      };
    });
    _defineProperty(this, "getData", () => {
      var attendee = {
        name: this.getFieldValue('name'),
        email: this.getFieldValue('email'),
        mobile: this.getFieldValue('mobile')
      };

      // V2 APIs applicable
      // when availableCalendarEvents and calendarEvents are empty
      if (this.props.isV2APIs) {
        attendee.postcode = this.getFieldValue('postcode');
        return _objectSpread(_objectSpread({}, this.getSelectedDateTime()), {}, {
          attendee
        });
      }

      // V1 APIs applicable
      // when availableCalendarEvents not empty
      return {
        calendarEventsIndex: this.state.isAvailableCalendarEvent ? undefined : this.state.calendarEventsIndex,
        availableCalendarEventsIndex: this.state.isAvailableCalendarEvent ? this.state.availableCalendarEventsIndex : undefined,
        attendee
      };
    });
    _defineProperty(this, "submitForm", () => {
      if (!this.validate()) {
        return;
      }
      this.setState({
        isSubmitting: true
      });
      this.props.onSubmit(this.getData()).then(() => {
        this.setState({
          isSubmitted: true,
          isSubmitting: false
        });
      }).catch(err => {
        this.setState({
          isSubmitted: true,
          isSubmitting: false,
          submitError: err
        });
      });
    });
    _defineProperty(this, "validateField", (key, value) => {
      var field = this.contactFields[key];
      var error;
      if (field.required && !value) {
        error = field.requiredErrorMessage;
      } else if (field.validate) {
        error = field.validate(value);
      }
      return {
        value,
        error: error || ''
      };
    });
    _defineProperty(this, "validate", () => {
      var newState = this.allFields.reduce((state, key) => _objectSpread(_objectSpread({}, state), {}, {
        [key]: this.validateField(key, this.state.contactFields[key].value)
      }), {});
      this.setState({
        contactFields: newState
      });
      if (!this.state.isAvailableCalendarEvent && !this.state.calendarEventsIndex || this.state.isAvailableCalendarEvent && !this.state.availableCalendarEventsIndex) {
        this.setState({
          startDateError: true
        });
        return false;
      }
      return Object.values(newState).every(_ref3 => {
        var error = _ref3.error;
        return !error;
      });
    });
    _defineProperty(this, "handleFieldChange", (key, value) => {
      var fieldState = this.validateField(key, value);
      this.setState(prevState => ({
        contactFields: _objectSpread(_objectSpread({}, prevState.contactFields), {}, {
          [key]: fieldState
        })
      }));
    });
    _defineProperty(this, "handleCustomDateChange", dateInstance => {
      var availableCalendarEventsTimeOptions = this.props.isV2APIs ? this.getV2TimeOptions(dateInstance) : this.getV1TimeOptions(dateInstance);
      this.setState({
        availableCalendarEventsTimeOptions,
        availableCalendarEventsSelectedDate: new Date(dateInstance),
        // default to first time available for that day
        availableCalendarEventsIndex: availableCalendarEventsTimeOptions[0].value
      });
    });
    _defineProperty(this, "handleCustomTimeChange", event => {
      this.setState({
        availableCalendarEventsIndex: event.value
      });
    });
    _defineProperty(this, "handleCustomDateSelection", () => {
      this.setState({
        isAvailableCalendarEvent: true,
        calendarEventsIndex: null,
        startDateError: false
      });
      this.closeCustomDateDialog();
    });
    _defineProperty(this, "closeCustomDateDialog", () => {
      this.setState({
        availableCalendarEventsModalOpen: false
      });
    });
    _defineProperty(this, "resetContactFields", () => {
      this.setState({
        contactFields: this.allFields.reduce((fields, key) => _objectSpread(_objectSpread({}, fields), {}, {
          [key]: {
            value: '',
            error: ''
          }
        }), {})
      });
    });
    _defineProperty(this, "resetForm", () => {
      this.setState({
        submitError: null,
        isSubmitted: false
      });
      this.resetContactFields();
    });
    _defineProperty(this, "launchCustomDateDialog", event => {
      event.preventDefault(); // because we are a button in a form it wants to submit otherwise
      this.setState({
        availableCalendarEventsModalOpen: true
      });
    });
    _defineProperty(this, "renderContactField", key => {
      var field = this.contactFields[key];
      var fieldState = this.state.contactFields[key];
      return ___EmotionJSX(ContactField, {
        iconName: field.icon,
        fieldName: key,
        placeHolder: "".concat(field.label).concat(field.required ? REQUIRED : ''),
        onValueChange: event => this.handleFieldChange(key, event.target.value),
        fieldError: fieldState.error,
        fieldValue: fieldState.value
      });
    });
    _defineProperty(this, "renderFormContent", () => {
      var hasCalendarEvents = this.hasCalendarEvents();
      return ___EmotionJSX("section", {
        css: styles.content
      }, ___EmotionJSX("div", {
        css: styles.title
      }, hasCalendarEvents ? 'Book inspection' : 'What time suits?'), ___EmotionJSX("div", {
        css: styles.subTitle
      }, hasCalendarEvents ? 'Register your attendance for simple check-ins.' : "Tell us your preferred date and time, and we'll reach out to the agent for you."), hasCalendarEvents ? ___EmotionJSX(SelectInspection, {
        options: this.props.calendarEvents.map((_ref4, index) => {
          var startDate = _ref4.startDate,
            endDate = _ref4.endDate;
          return {
            value: "".concat(index),
            label: "".concat(format(startDate, FORMAT_DATE_AND_TIME), " - ").concat(format(endDate, FORMAT_TIME))
          };
        }),
        onChange: this.onChangeInspectionOption,
        launchCustomDateDialog: this.launchCustomDateDialog,
        hasAvailableCalendarEvents: this.hasAvailableCalendarEvents(),
        value: this.state.calendarEventsIndex,
        fieldError: this.state.startDateError,
        selectedAvailableCalendarEventLabel: this.state.isAvailableCalendarEvent ? "".concat(format(this.props.availableCalendarEvents[this.state.availableCalendarEventsIndex].startDate, FORMAT_DATE_AND_TIME), " - ").concat(format(this.props.availableCalendarEvents[this.state.availableCalendarEventsIndex].endDate, FORMAT_TIME)) : undefined
      }) : ___EmotionJSX("div", {
        css: styles.customDateInputsContainer
      }, ___EmotionJSX(CustomDateInputs, {
        availableCalendarEvents: this.props.availableCalendarEvents,
        availableCalendarEventsTimeOptions: this.state.availableCalendarEventsTimeOptions,
        availableCalendarEventsSelectedDate: this.state.availableCalendarEventsSelectedDate,
        availableCalendarEventsIndex: this.state.availableCalendarEventsIndex,
        onDateChange: this.handleCustomDateChange,
        onTimeChange: this.handleCustomTimeChange,
        isV2APIs: this.props.isV2APIs,
        theme: this.props.theme
      })), this.renderContactField('name'), this.renderContactField('email'), this.renderContactField('mobile'), this.props.isV2APIs && this.renderContactField('postcode'), ___EmotionJSX("div", {
        css: styles.terms
      }, "By booking, I agree to the Domain and Homepass\xA0", ___EmotionJSX(LinkButton, {
        appearance: "link",
        href: this.props.privacyUrl,
        css: styles.privacyLinkButton,
        target: "_blank"
      }, "Privacy Policy"), ".\xA0", ___EmotionJSX(ClassNames, null, _ref5 => {
        var css = _ref5.css;
        return ___EmotionJSX(Tooltip, {
          content: this.props.privacyCopy,
          placement: "bottom",
          trigger: "click",
          overlayClassName: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n                  z-index: ", " !important;\n                "])), vars.global.layerModal)
        }, ___EmotionJSX(Button, {
          appearance: "link",
          tabIndex: 0,
          css: styles.moreInfoButton
        }, "Click for more information"));
      }), "."), ___EmotionJSX(Button, {
        css: styles.submitButton,
        "data-testid": "homepass-booking__submit-button",
        onClick: this.submitForm,
        disabled: this.state.isSubmitting
      }, this.state.isSubmitting ? ___EmotionJSX(Loader, {
        css: styles.submitButtonLoader,
        dark: true,
        transparent: true,
        size: "mini"
      }) : this.props.submitButtonText), ___EmotionJSX(Button, {
        css: styles.cancelButton,
        appearance: "link",
        onClick: this.onCloseModalCallback
      }, "Cancel"));
    });
    this.contactFields = {
      name: {
        label: 'Full Name',
        icon: 'profile',
        required: true,
        requiredErrorMessage: 'Please enter your full name'
      },
      email: {
        label: 'Email',
        icon: 'email',
        required: true,
        requiredErrorMessage: 'Please enter your email address',
        validate: value => validEmail(value) ? '' : 'Invalid email address'
      },
      mobile: {
        label: 'Mobile',
        icon: 'phone',
        required: true,
        requiredErrorMessage: 'Please enter your mobile number',
        validate: value => isValidNumber(value, COUNTRY_NUMBER_FORMAT) ? '' : 'Please enter a valid mobile number'
      }
    };
    if (this.props.isV2APIs) {
      this.contactFields.postcode = {
        label: 'Postcode',
        icon: 'postCode',
        required: false,
        validate: value => /^$|^\d{4}$/.test(value) ? '' : 'Please enter a valid postcode'
      };
    }
    this.allFields = Object.keys(this.contactFields);
    var firstAvailableCalendarEvent = () => {
      if (this.props.isV2APIs) {
        var currDateTime = new Date();
        var lastInspectionTimeToday = startOfToday().setHours(LAST_INSPECTION_TIME);
        if (isAfter(currDateTime, lastInspectionTimeToday)) {
          // if current time later than LAST_INSPECTION_TIME: 20:00 local time
          // set the first date to next day
          return startOfTomorrow();
        }
        return currDateTime;
      }
      return this.hasAvailableCalendarEvents() && new Date(this.props.availableCalendarEvents[0].startDate);
    };
    this.state = {
      // null is important because fe-co-select (downshift) must always be in controlled mode, not undefined.
      // see https://github.com/paypal/downshift/blob/92b5ad0011140836b2196d9e6bf17036945047d7/src/downshift.js#L1198-L1221
      calendarEventsIndex: null,
      isSubmitted: false,
      isSubmitting: false,
      submitError: null,
      // availableCalendarEvents concern
      availableCalendarEventsModalOpen: false,
      // because if there are no `calendarEvents` we default to the first `availableCalendarEvents`
      isAvailableCalendarEvent: !this.hasCalendarEvents(),
      availableCalendarEventsIndex: '0',
      // note we are keeping the values as strings
      availableCalendarEventsSelectedDate: firstAvailableCalendarEvent(),
      availableCalendarEventsTimeOptions: this.props.isV2APIs ? this.getV2TimeOptions(firstAvailableCalendarEvent()) : this.hasAvailableCalendarEvents() && this.getV1TimeOptions(firstAvailableCalendarEvent()),
      // form field concern
      startDateError: false,
      contactFields: {
        name: {
          value: this.props.initialName,
          error: ''
        },
        email: {
          value: this.props.initialEmail,
          error: ''
        },
        mobile: {
          value: this.props.initialMobile,
          error: ''
        },
        postcode: {
          value: this.props.initialPostcode,
          error: ''
        }
      }
    };
  }
  /**
   * get time options when V2 APIs applied
   */
  getV2TimeOptions(dayToLookFor) {
    var timeOptions = [];
    for (var currHours = FIRST_INSPECTION_TIME; currHours < LAST_INSPECTION_TIME; currHours += 1) {
      var timeNow = new Date();
      if (isAfter(startOfDay(dayToLookFor).setHours(currHours, TIME_INTERVAL), timeNow)) {
        timeOptions.push(this.getTimeSlots({
          index: timeOptions.length,
          hour: currHours,
          day: dayToLookFor,
          startMinsOffset: 0,
          endMinsOffset: TIME_INTERVAL,
          hrsOffset: 0
        }));
      }
      if (isAfter(startOfDay(dayToLookFor).setHours(currHours + 1), timeNow)) {
        timeOptions.push(this.getTimeSlots({
          index: timeOptions.length,
          hour: currHours,
          day: dayToLookFor,
          startMinsOffset: TIME_INTERVAL,
          endMinsOffset: 0,
          hrsOffset: 1
        }));
      }
    }
    return timeOptions;
  }

  /**
   * get time options when V1 APIs applied
   */
  getV1TimeOptions(dayToLookFor) {
    return this.props.availableCalendarEvents.map((_ref6, index) => {
      var startDate = _ref6.startDate,
        endDate = _ref6.endDate;
      return {
        index,
        startDate: new Date(startDate),
        endDate: new Date(endDate)
      };
    }).filter(_ref7 => {
      var startDate = _ref7.startDate;
      return isSameDay(new Date(startDate), new Date(dayToLookFor));
    }).map(_ref8 => {
      var startDate = _ref8.startDate,
        endDate = _ref8.endDate,
        index = _ref8.index;
      return {
        value: "".concat(index),
        label: "".concat(format(startDate, 'h:mm'), " - ").concat(format(endDate, FORMAT_TIME))
      };
    });
  }
  hasCalendarEvents() {
    return this.props.calendarEvents.length > 0;
  }
  hasAvailableCalendarEvents() {
    return this.props.availableCalendarEvents.length > 0;
  }
  renderConfirmationPage() {
    var startDate;
    var endDate;
    if (this.props.isV2APIs) {
      var _this$getSelectedDate = this.getSelectedDateTime(),
        selectedStartDateTime = _this$getSelectedDate.startDate,
        selectedEndDateTime = _this$getSelectedDate.endDate;
      startDate = new Date(selectedStartDateTime).toISOString();
      endDate = new Date(selectedEndDateTime).toISOString();
    } else {
      var _ref9 = this.state.isAvailableCalendarEvent ? this.props.availableCalendarEvents[this.state.availableCalendarEventsIndex] : this.props.calendarEvents[this.state.calendarEventsIndex];
      startDate = _ref9.startDate;
      endDate = _ref9.endDate;
    }
    return ___EmotionJSX(ConfirmationPage, {
      isError: !!this.state.submitError,
      startDate: startDate,
      endDate: endDate,
      listingAddress: this.props.listingAddress,
      onCloseModalCallback: this.onCloseModalCallback,
      isAvailableCalendarEvent: this.state.isAvailableCalendarEvent
    });
  }
  render() {
    var defaultLogos = ___EmotionJSX("div", {
      css: styles.logos
    }, ___EmotionJSX(LinkButton, {
      css: styles.domainLogoLink,
      appearance: "link",
      href: "https://www.domain.com.au"
    }, ___EmotionJSX(DomainLogo, null)), ___EmotionJSX("img", {
      alt: "Homepass logo",
      src: "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-homepass-booking/static/homepass-logo-blue_62759e9e.png",
      width: "112",
      height: "26"
    }));
    return ___EmotionJSX("div", {
      css: styles.container
    }, ___EmotionJSX("form", null, ___EmotionJSX("div", {
      css: styles.logoContainer
    }, this.props.customLogos || defaultLogos), this.state.isSubmitted ? this.renderConfirmationPage() : this.renderFormContent(), this.state.availableCalendarEventsModalOpen && ___EmotionJSX(CustomDateDialog, {
      availableCalendarEventsSelectedDate: this.state.availableCalendarEventsSelectedDate,
      availableCalendarEventsIndex: this.state.availableCalendarEventsIndex,
      closeCallback: this.closeCustomDateDialog,
      onDateSelection: this.handleCustomDateSelection,
      onDateChange: this.handleCustomDateChange,
      onTimeChange: this.handleCustomTimeChange,
      availableCalendarEvents: this.props.availableCalendarEvents,
      availableCalendarEventsTimeOptions: this.state.availableCalendarEventsTimeOptions
    })));
  }
}
var availableCalendarEventsPropType = PropTypes.arrayOf(PropTypes.shape({
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired
}));
HomepassBookingForm.propTypes = {
  privacyUrl: PropTypes.string.isRequired,
  privacyCopy: PropTypes.node.isRequired,
  listingAddress: PropTypes.string.isRequired,
  calendarEvents: availableCalendarEventsPropType,
  availableCalendarEvents: availableCalendarEventsPropType,
  submitButtonText: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onCloseModalCallback: PropTypes.func,
  initialName: PropTypes.string,
  initialEmail: PropTypes.string,
  initialMobile: PropTypes.string,
  initialPostcode: PropTypes.string,
  customLogos: PropTypes.node,
  isV2APIs: PropTypes.bool,
  theme: PropTypes.string
};
HomepassBookingForm.defaultProps = {
  onCloseModalCallback: () => {},
  initialName: '',
  initialEmail: '',
  initialMobile: '',
  initialPostcode: '',
  calendarEvents: [],
  availableCalendarEvents: [],
  submitButtonText: 'Book inspection',
  customLogos: null,
  isV2APIs: false,
  theme: 'domain'
};
export default HomepassBookingForm;